import PropTypes from 'prop-types'

import { Columns } from '@domain-group/suit-theme'

import useService from '@hooks/useService'
import useServiceProduct from '@hooks/useServiceProduct'

import LinkToEntityModule from '@components/LinkToEntityModule'
import TemplatePageList from '@components/TemplatePageList'

import AssignedPublications from '../AssignedPublications'
import CompatibleProducts from '../CompatibleProducts'
import EditorialPublications from '../EditorialPublications'
import OrderBundles from '../OrderBundles'
import PageLayout from '../../../../components/PageLayout'
import ProviderPackages from '../ProviderPackages'
import ProviderPriceLists from '../ProviderPriceLists'
import ServiceProductTools from '../../../../components/ServiceProductTools'

const PageContent = (props) => {
  const { serviceProductId } = props

  const serviceProductPayload = useServiceProduct({ id: serviceProductId })
  const {
    callbacks: {
      launchDuplicateServiceProductModal,
      manageServiceProductTaskOptions,
    },
    loading,
    service,
  } = serviceProductPayload

  const servicePayload = useService(service)
  const {
    isForEditorial,
    isForPublication,
    service: { title: serviceTitle, short_name: serviceShortName },
    urls: { servicesIndexUrl },
  } = servicePayload

  return (
    <PageLayout entityPayload={serviceProductPayload} activeTabBarItemKey="relations">
      <Columns.Main>
        {isForPublication && (
          <AssignedPublications serviceProductPayload={serviceProductPayload} />
        )}

        <OrderBundles serviceProductId={serviceProductId} />

        <CompatibleProducts serviceProductPayload={serviceProductPayload} />

        {isForEditorial && (
          <EditorialPublications serviceProductPayload={serviceProductPayload} />
        )}

        <TemplatePageList
          allowedFilters={['agency_id', 'brand_id']}
          filterIds={{ service_product_id: serviceProductId }}
        />

        <ProviderPackages serviceProductPayload={serviceProductPayload} serviceProductId={serviceProductId} />

        <ProviderPriceLists serviceProductId={serviceProductId} />
      </Columns.Main>

      <Columns.Sidebar>
        <LinkToEntityModule
          entityTitle={serviceTitle}
          goToHref={servicesIndexUrl}
          loading={loading}
          moduleTitle="Service"
          secondaryText={serviceShortName}
        />

        <ServiceProductTools
          callbacks={{ launchDuplicateServiceProductModal, manageServiceProductTaskOptions }}
          service={service}
        />
      </Columns.Sidebar>
    </PageLayout>
  )
}

PageContent.propTypes = {
  serviceProductId: PropTypes.number.isRequired,
}

export default PageContent
